// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["./src/static/carousel/view.js"](0, __webpack_exports__);
